import Badge from '@amzn/awsui-components-react-v3/polaris/badge';

import { AppLayout, Tooltip } from 'AWS-UI-Components-React';
import React from 'react';
import { isPowerUser } from '../../utils/access-utils';
import { AccuracyInfo } from './accuracy_benchmark_info';

import { MapperForm } from './mapper_form';

export const Change = {
  ADD: 'New',
  MODIFY: 'Modified',
  DELETE: 'Deleted',
};

export const Badges = {
  New: (item) => {
    return (
      <span key="new">
        { item }
        { '  ' }
        <Badge color="green"> { Change.ADD } </Badge>
      </span>
    );
  },
  Modified: (item) => {
    return (
      <span key="modified">
        { item }
        { '  ' }
        <Badge color="blue"> { Change.MODIFY } </Badge>
      </span>
    );
  },
  Deleted: (item) => {
    return (
      <span key="deleted">
        <del>{ item }</del>
        { '  ' }
        <Badge color="red"> { Change.DELETE } </Badge>
      </span>
    );
  },
  Excluded: (text) => {
    return (
      <Tooltip key="excluded" text={ text } position="top">
        { ' ' }
        <Badge color="grey"> Excluded </Badge>
      </Tooltip>
    );
  },
  Ignored: (text) => {
    return (
      <Tooltip key="ignored" text={ text } position="top">
        { ' ' }
        <Badge color="red"> Ignored </Badge>
      </Tooltip>
    );
  },
};

export const KeyOriginalMapping = {
  'cpValueMap': 'originalCPValueMap',
  'accuracyBenchmark': 'originalAccuracyBenchmark',
  'cognosBenchmark': 'originalCognosBenchmark',
  'baseFactor': 'originalBaseFactor',
  'cpDataSource': 'originalCpDataSource',
  'reallocationGrain': 'originalReallocationGrain',
  'subcomponentRollup': 'originalSubcomponentRollup',
  'comment': 'originalComment',
};

export class Mapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toolsContent: <AccuracyInfo />,
      toolsOpen: false,
    };
  }
  render() {
    return (
      <div>
        <AppLayout
          className="awsui-util-no-gutters"
          content={
            <MapperForm
              identity={ this.props.identity }
              readOnly={ !isPowerUser(this.props.identity) }
              featureList={ this.props.featureList }
              updateTools={ (toolsContentNew) => {
                this.setState({ toolsContent: toolsContentNew, toolsOpen: true });
              }}
              updateToolsContent={ (toolsContentNew) => {
                this.setState({ toolsContent: toolsContentNew });
              }}
          /> }
          navigationHide={ true }
          tools={ this.state.toolsContent }
          toolsOpen={ this.state.toolsOpen }
          onToolsChange={ ({detail}) => this.state.toolsOpen = detail.open }
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/mapper/mapper.jsx